import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    setSubmitted(false);

    emailjs
      .sendForm(
        'service_11ci7oj',
        'template_k8y0ewh',
        e.target,
        'xiz5PeioP8xSr3vVT'
      )
      .then(
        () => {
          setSubmitted(true);
          e.target.reset();
        },
        (err) => {
          console.error('EmailJS error:', err);
          setError(true);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="bg-ehh-cream text-ehh-navy">
      {/* Hero Section - Professional with strong readability */}
      <section className="relative min-h-[80vh] flex items-center justify-center text-center overflow-hidden">
        <img 
          src="/assets/images/contact-hero-united-hands.jpg" 
          alt="United hands in circle symbolizing community partnership and hope" 
          className="absolute inset-0 w-full h-full object-cover" 
        />
        <div className="absolute inset-0 bg-ehh-navy/75"></div>
        <div className="relative z-10 container mx-auto px-6 sm:px-8 md:px-12 max-w-5xl">
          <div className="py-12 sm:py-16 md:py-20">
            <img src="/logo.png" alt="EMA House of Hope Logo" className="mx-auto h-24 sm:h-28 md:h-32 mb-6 sm:mb-8" />
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 sm:mb-6 text-ehh-cream">
              Connect With Us
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl max-w-4xl mx-auto mb-8 sm:mb-10 leading-relaxed text-ehh-peach px-4 sm:px-0">
              Partner with EMA House of Hope to synchronise interventions in foundational well-being, economic empowerment, and community health—advancing sustainable transformation in Zambia.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form Section - Clean, centred card */}
      <section className="py-24 px-6 -mt-20 relative z-10">
        <div className="container mx-auto max-w-3xl">
          <div className="bg-white rounded-2xl shadow-2xl p-12">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-ehh-orange">
              Send a Message
            </h2>

            {submitted ? (
              <div className="text-center py-12">
                <p className="text-2xl font-medium mb-6 text-ehh-navy">Thank you for your message</p>
                <p className="text-lg">We have received it and will respond promptly at support@emahouseofhope.org.</p>
              </div>
            ) : error ? (
              <div className="text-center py-12">
                <p className="text-2xl font-medium mb-6 text-ehh-peach">Submission Error</p>
                <p className="text-lg">Please try again or contact us directly at support@emahouseofhope.org.</p>
              </div>
            ) : (
              <form onSubmit={sendEmail} className="space-y-8">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="w-full px-6 py-4 text-ehh-navy text-base rounded-lg border border-gray-300 focus:border-ehh-orange focus:outline-none transition"
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  className="w-full px-6 py-4 text-ehh-navy text-base rounded-lg border border-gray-300 focus:border-ehh-orange focus:outline-none transition"
                />

                <input
                  type="text"
                  name="title"
                  placeholder="Subject"
                  required
                  className="w-full px-6 py-4 text-ehh-navy text-base rounded-lg border border-gray-300 focus:border-ehh-orange focus:outline-none transition"
                />

                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="6"
                  required
                  className="w-full px-6 py-4 text-ehh-navy text-base rounded-lg border border-gray-300 focus:border-ehh-orange focus:outline-none transition resize-none"
                />

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-ehh-orange text-ehh-cream py-5 rounded-lg text-xl font-semibold hover:bg-ehh-coral transition-shadow shadow-lg disabled:opacity-70"
                >
                  {loading ? 'Sending...' : 'Submit Message'}
                </button>
              </form>
            )}

            <div className="mt-12 pt-8 border-t border-gray-200 text-center space-y-4">
              <p className="text-base">
                <strong>Email:</strong>{' '}
                <a href="mailto:support@emahouseofhope.org" className="text-ehh-orange hover:underline">
                  support@emahouseofhope.org
                </a>
              </p>
              <p className="text-base">
                <strong>Phone:</strong>{' '}
                <a href="tel:+260977770071" className="text-ehh-orange hover:underline">
                  +260 961121278
                </a>
              </p>
              <p className="text-base">
                <strong>Physical Address:</strong> Plot No. 25587, Borderview, woodlands, Lusaka
              </p>
              <p className="text-base">
                <strong>Postal Address:</strong> P.O. Box 39019, Lusaka – Zambia
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Closing Section - Subtle community image */}
      <section className="py-24 px-6 text-center relative overflow-hidden bg-ehh-navy/5">
        <img 
          src="/assets/images/contact-closing-community.jpg" 
          alt="Smiling Zambian community connected in hope" 
          className="absolute inset-0 w-full h-full object-cover opacity-15" 
        />
        <div className="relative container mx-auto max-w-5xl">
          <p className="text-2xl md:text-4xl font-medium mb-8 leading-relaxed">
            We look forward to collaborating toward resilient, thriving communities.
          </p>
          <p className="text-xl">Your partnership advances lasting change in Zambia.</p>
        </div>
      </section>
    </div>
  );
};

export default Contact;